export default __webpack_public_path__ + "static/media/home.2ca354d3.png";